/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
  CardBody,
  InputGroup,
  InputGroupText,
  Alert,
} from "reactstrap";
import FootprintInputButton from "../../../Components/utils/FootprintInputButton";

import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";
import moment from "moment";
import { DEFAULT_FORMAT } from "../../../Components/utils/FootprintDatePicker";
import { useRequestProcessor } from "../../../requestProcessor";

import { useAtom } from "jotai";
import {
  activeChildDetail,
  appConstants,
  mobileAtom,
  requestType,
} from "../../../AtomStore/store";

import { useNavigate } from "react-router-dom";
import {
  fetchCenters,
  fetchProgramList,
  submitProgramChange,
} from "../../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { StyledCardHeader } from "./styles";
import { FaAngleDown } from "react-icons/fa";

const ChangeProgram = () => {
  const navigate = useNavigate();
  const { useQueryWrapper, useMutationWrapper } = useRequestProcessor();

  const [selectedDate, setSelectedDate] = useState();
  const [selectedProgram, setSelectedProgram] = useState();
  const [holidaySelected, setHolidaySelected] = useState();
  const [error, setError] = useState();
  const [result, setResult] = useState();
  const [reqType] = useAtom(requestType);
  const [activeChild] = useAtom(activeChildDetail);

  const [constants] = useAtom(appConstants);
  const [program, setProgram] = useState();
  const { data: fetched_program } = useQueryWrapper(
    ["program", "program" + activeChild?.id],
    () => fetchProgramList(setResult)
  );

  console.log("fetche program", fetched_program);
  useMemo(() => {
    console.log(
      "[Change Program] Initializing Change program form for child:",
      activeChild?.id
    );
  }, []);

  const {} = useQueryWrapper(
    ["Centers", activeChild?.id],
    () => {
      console.log("[My Center] Calling API: /parentapp/getCenterJSON", {
        child_id: activeChild.id,
      });

      return fetchCenters();
    },
    {
      onSuccess: (data) => {
        console.log("[My Center] Get Centers data response:", data);
        let programs_available = reqType?.programs_available;
        let global_programs = data?.Programs_Available?.split(",");
        let fetched_programs = fetched_program;

        let validPrograms = [];

        if (programs_available && global_programs) {
          const availableList = programs_available.split(",");

          // Step 1: filter against global list
          const filteredList = availableList.filter((program) =>
            global_programs.includes(program)
          );

          // Step 2: filter fetched programs with matching values
          validPrograms = fetched_programs.filter((program) =>
            filteredList.includes(program.value)
          );
        }

        setProgram(validPrograms);
      },
    }
  );

  const changeProgram = useMutationWrapper(
    "changeProgram",
    () => {
      console.log("[Change Program] Calling API: /parentapp/request ", {
        selectedDate,
        selectedProgram,
      });

      return submitProgramChange(selectedDate, selectedProgram, navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[Change Program] Take a break response:", data);
      },
    }
  );
  const validate = () => {
    if (holidaySelected === true) {
      setError("The Selected Date Cannot Be a Holiday");

      return false;
    } else if (selectedDate === undefined) {
      setError("Please Select Date");

      return false;
    } else if (selectedProgram === undefined || selectedProgram === "") {
      setError("Please Select Program");

      return false;
    } else {
      return true;
    }
  };

  const submit = (type) => {
    if (validate()) {
      changeProgram.mutate();
    } else {
    }
  };

  console.log("Set types", reqType);

  return (
    <div className="m-[10px] mt-[20px]">
      <div className="bg-white rounded shadow p-2 pb-4">
        <div className="md:p-2">
          {changeProgram.isLoading && <SpinnerLoading />}

          <div className="bg-yellow-100 text-yellow-800 p-4 rounded mb-4 text-sm">
            {constants?.changeProgramTitle}
          </div>

          <form>
            {/* Current Program */}
            <div className="mb-4">
              <label
                htmlFor="programCurrent"
                className="block text-sm font-medium text-black mb-1"
              >
                Current Program
              </label>
              {typeof result !== "undefined" &&
                typeof result.label === "string" && (
                  <input
                    type="text"
                    name="programCurrent"
                    id="programCurrent"
                    placeholder={result.label}
                    value={result.label}
                    disabled
                    className="w-full p-3 border-1  rounded bg-gray-100 text-gray-700"
                  />
                )}
            </div>

            {/* New Program & Date */}
            <hr className=" mx-2 mt-2  bg-black" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              {/* New Program Select */}
              <div className="mt-3">
                <label
                  htmlFor="newProgramSelect"
                  className="block text-sm font-medium text-black mb-2"
                >
                  New Program
                </label>

                <div className="relative">
                  <select
                    className="w-full appearance-none focus:outline-none text-[#b2bac2] bg-white "
                    onChange={(event) => {
                      setError(undefined);
                      setSelectedProgram(event.target.value);
                    }}
                  >
                    <option value="" hidden>
                      Select Program
                    </option>
                    {program
                      ?.filter((item) => item.value !== result?.value)
                      .map((item, i) => (
                        <option key={i} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-gray-500">
                    <FaAngleDown className="" />
                  </div>
                </div>
              </div>
              <hr className=" mx-2 bg-black md:hidden" />

              {/* From Date Picker */}
              <div className="">
                <label
                  htmlFor="startDate"
                  className="block text-sm font-medium text-black"
                >
                  From Date
                </label>

                <div className="flex items-center  border-black rounded-sm">
                  <FootprintDatePicker
                    holidaySelected={(selected) => {
                      setError("The selected Date Cannot Be a Holiday");
                      setHolidaySelected(selected);
                    }}
                    disableWeekends={true}
                    inputProps={{ placeholder: "Select Date" }}
                    minimumDate={moment()}
                    onChange={(date) => {
                      // const day = moment(date).day();
                      // if (day === 0 || day === 6) {
                      //   setError(
                      //     "Weekends (Saturday and Sunday) are not allowed"
                      //   );
                      //   setSelectedDate(undefined);
                      //   return;
                      // }

                      setHolidaySelected(false);
                      setSelectedDate(moment(date).format(DEFAULT_FORMAT));
                      setError(undefined);
                    }}
                  />
                  <i className="icon-calender text-2xl text-black" />
                </div>
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div className="text-red-600 text-sm font-medium mb-4">
                {error}
              </div>
            )}

            {/* Submit Button */}
            <div className="text-center">
              <FootprintInputButton
                style={{ color: "white" }}
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
                onClick={submit}
              >
                Submit
              </FootprintInputButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangeProgram;
